import { Box, Typography, useTheme } from "@mui/material";

const AppFooter = () => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        ...theme.customStyles.flexBetween,
        height: "48px",
        paddingInline: "24px",
        backgroundColor: theme.palette.background.default,
        borderTop: "1px #4C4E641F solid",
        color: theme.palette.primary.main,
      }}
    >
      <Typography sx={{ fontWeight: "300", fontSize: "14px" }}>
        © OnlineJustice 2025
      </Typography>
    </Box>
  );
};

export default AppFooter;
